// import React from "react";
// import { Link } from "react-router-dom";

// const Address = () => {
//   return (
//     <div>
//       <div className="bag-section container-fluid" style={{marginTop:"115px"}}>
//         <div className="bagheader">
//           <div className="nav-logo">
//             <Link to="/">
//               <img src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png" alt="logo" />
//             </Link>
//           </div>
//           <div className="headerCenter">
//             <Link to="/bag">BAG -------- </Link>
//             <Link to="/address"> ADDRESS -------- </Link>
//             <Link to="/payment">PAYMENT</Link>
//           </div>
//           <div className="headerRight">
//             <img
//               className="image2"
//               src="https://constant.myntassets.com/checkout/assets/img/sprite-secure.png"
//             />
//             <span> 100% SECURE</span>
//           </div>
//         </div>
//       </div>

//       <div className="container address-section">
//         <div className="row d-flex justify-content-center">
//           <div className="col-lg-5 col-md-6 col-sm-12 address">
//             <form id="addressForm">
//               <div className="container1">
//                 <h3>CONTACT DETAILS</h3>
//                 <input
//                   className="contactdetail"
//                   id="name"
//                   type="text"
//                   placeholder="NAME*"
//                 />
//                 <br />
//                 <br />
//                 <input
//                   className="contactdetail"
//                   id="mobileNo"
//                   type="number"
//                   placeholder="Mobile No*"
//                 />
//                 <br />
//                 <br />
//               </div>
//               <div className="container1">
//                 <h3>ADDRESS</h3>
//                 <input
//                   className="contactdetail"
//                   id="pincode"
//                   type="number"
//                   placeholder="Pin Code*"
//                 />
//                 <br />
//                 <br />
//                 <input
//                   className="contactdetail"
//                   id="address"
//                   type="text"
//                   placeholder="Address (House No, Building, Street, Area)*"
//                 />
//                 <br />
//                 <br />
//                 <input
//                   className="contactdetail"
//                   id="location"
//                   type="text"
//                   placeholder="Location/Town*"
//                 />
//                 <br />
//                 <br />
//                 <input
//                   className="data"
//                   id="data2"
//                   type="text"
//                   placeholder="City*"
//                 />
//                 <input
//                   className="data"
//                   id="data1"
//                   type="text"
//                   placeholder="State*"
//                 />
//               </div>
//             </form>

//             <div className="container1">
//               <h3>ADDRESS TYPE</h3>

//               <label>
//                 <input type="radio" name="addressType" className="button1" />
//                 Home
//               </label>

//               <label style={{ marginLeft: "20px" }}>
//                 <input type="radio" name="addressType" className="button1" />
//                 Office
//               </label>

//               <br />
//               <br />

//               <input type="checkbox" id="checkBox" />
//               <label htmlFor="checkBox" style={{ fontSize: 14, marginLeft: 8 }}>
//                 Make this my Default Address
//               </label>
//             </div>

//             <div className="container2">
//               <Link to="/payment">
//               <button className="button2" onclick="addAddress()">
//                 ADD ADDRESS
//               </button>
//               </Link>
//             </div>
//           </div>

//           <div className="col-lg-5 col-md-3 col-sm-12 address-price-section">
//             <p className="section-title">PRICE DETAILS (1 Item)</p>
//             <div className="price-row">
//               <span>Total MRP</span>
//               <span>₹1,999</span>
//             </div>
//             <div className="price-row">
//               <span>
//                 Discount on MRP <span className="know-more">Know More</span>
//               </span>
//               <span className="green">-₹1,500</span>
//             </div>
//             <div className="price-row">
//               <span>Coupon Discount</span>
//               <button className="coupon-link">Apply Coupon</button>
//             </div>
//             <div className="price-row">
//               <span>
//                 Platform Fee <span className="know-more">Know More</span>
//               </span>
//               <span>
//                 <s>₹99</s> Free
//               </span>
//             </div>
//             <hr />
//             <div className="price-row total">
//               <span>Total Amount</span>
//               <span>₹499</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Address;



import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const Address = () => {
  const navigate = useNavigate();
  const user_id = localStorage.getItem("user_id");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    pincode: "",
    address: "",
    location: "",
    city: "",
    state: "",
    address_type: "Home",
    is_default: 0,
  });


  const [addressList, setAddressList] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [subtotal, setSubtotal] = useState("0.00");
  const [totalDiscount, setTotalDiscount] = useState("0.00");
  const [grandTotal, setGrandTotal] = useState("0.00");
  const [cartCount, setCartCount] = useState(0);
  const [addressSuggestions, setAddressSuggestions] = useState([]);


  useEffect(() => {
    if (user_id) {
      fetchAddresses();
      fetchCartTotals();
    }
  }, [user_id]);

  useEffect(() => {
    getLocation();
    const saved = JSON.parse(localStorage.getItem("savedAddresses") || "[]");
    setAddressSuggestions(saved);
  }, []);

  const fetchAddresses = async () => {
  try {
    const res = await axios.post(
      "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_contact_details_address",
      { user_id }
    );

    if (res.data.status === "true" || res.data.state === true) {
      const list = res.data.data || [];
      setAddressList(list);

      if (list.length > 0) {
        setSelectedAddressId(list[list.length - 1].contact_id);
      }
    }
  } catch (err) {
    console.error(err);
  }
};



  const fetchCartTotals = async () => {
    try {
      const form = new FormData();
      form.append("user_id", user_id);

      const res = await axios.post(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_cart",
        form,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data?.status === true || res.data?.status === "true") {
        setSubtotal(res.data.subtotal || "0.00");
        setTotalDiscount(res.data.total_discount || "0.00");
        setGrandTotal(res.data.grand_total || "0.00");
        setCartCount(res.data.data?.length || 0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getLocation = () => {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(async (position) => {
      const { latitude, longitude } = position.coords;
      try {
        const res = await axios.get(
          `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
        );
        setFormData((prev) => ({
          ...prev,
          city: res.data.city || prev.city,
          state: res.data.principalSubdivision || prev.state,
          country: "India",
        }));
      } catch (err) {
        console.log("Location fetch error");
      }
    });
  };


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    });
  };


  const validateAddressForm = () => {
  const { name, phone, pincode, address, location, city, state } = formData;

  
  if (!name.trim()) return toast.error("Name is required");

  if (!/^[A-Za-z\s]+$/.test(name))
    return toast.error("Name should contain only letters");

  if (name.trim().length < 3)
    return toast.error("Name must be at least 3 characters");

  
  if (!phone.trim()) return toast.error("Mobile number is required");

  if (!/^[6-9]\d{9}$/.test(phone))
    return toast.error("Enter valid 10 digit mobile number");


  if (!pincode.trim()) return toast.error("Pincode is required");

  if (!/^\d{6}$/.test(pincode))
    return toast.error("Enter valid 6 digit pincode");

  
  if (!address.trim()) return toast.error("Address is required");
  if (!location.trim()) return toast.error("Location is required");
  if (!city.trim()) return toast.error("City is required");
  if (!state.trim()) return toast.error("State is required");

  return true;
};


  
  const addAddress = async () => {
    if (!user_id) return toast.error("User not logged in");
    if (!validateAddressForm()) return;

    const payload = {
      user_id: Number(user_id),
      ...formData,
      total: 0,
    };

    try {
      const res = await axios.post(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/add_contact_details_address",
        JSON.stringify(payload),
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.status === "true") {
        toast.success("Address added successfully");

        
        const newAddressId = res.data.contact_id || res.data.data?.contact_id;

        if (newAddressId) {
          setSelectedAddressId(newAddressId);
        }

        setFormData({
          name: "",
          phone: "",
          pincode: "",
          address: "",
          location: "",
          city: "",
          state: "",
          address_type: "Home",
          is_default: 0,
        });
        fetchAddresses();
      } else {
        toast.error(res.data.message);
      }
    } catch {
      toast.error("Server error");
    }
  };

  const proceedWithSelectedAddress = () => {
    if (!selectedAddressId) {
      toast.error("Please select an address");
      return;
    }
    localStorage.setItem("selected_address_id", selectedAddressId);
  };
  

  return (
    <div>
      <div className="container address-section">
        <div className="row d-flex justify-content-center" style={{ marginTop: "115px" }}>
          <div className="col-lg-5 col-md-6 col-sm-12 address" style={{ width: "800px" }}>

            <div className="container1">
              <h3>CONTACT DETAILS</h3>
              <input className="contactdetail" name="name" placeholder="NAME*" value={formData.name} onChange={handleChange} required/>
              <br /><br />
              <input className="contactdetail" name="phone" placeholder="Mobile No*" value={formData.phone} onChange={handleChange} required/>
            </div>

            <div className="container1">
              <h3>ADDRESS</h3>
              <input className="contactdetail" name="pincode" placeholder="Pin Code*" value={formData.pincode} onChange={handleChange} required />
              <br /><br />
              <input className="contactdetail" name="address" placeholder="Address Line 1*" value={formData.address} onChange={handleChange} required />
              <br /><br />
              <input className="contactdetail" name="address2" placeholder="Address Line 2"value={formData.address2} onChange={handleChange} />
              <br /><br />
              <input className="contactdetail" name="location" placeholder="Location*" value={formData.location} onChange={handleChange} required/>
              <br /><br />
              <input className="contactdetail" name="landmark" placeholder="Landmark*" value={formData.landmark} onChange={handleChange} required/>
              <br /><br />
              <input className="data me-4" name="city" placeholder="City*" value={formData.city} onChange={handleChange} required />
              <input className="data" name="state" placeholder="State*" value={formData.state} onChange={handleChange} required />
            </div>

            <div className="container1">
              <h3>ADDRESS TYPE</h3>
              <label>
                <input type="radio" name="address_type" value="Home" checked={formData.address_type === "Home"} onChange={handleChange} /> Home
              </label>
              <label style={{ marginLeft: "20px" }}>
                <input type="radio" name="address_type" value="Office" checked={formData.address_type === "Office"} onChange={handleChange} /> Office
              </label>
              <br /><br />
              <input type="checkbox" name="is_default" checked={formData.is_default === 1} onChange={handleChange} />
              <label style={{ marginLeft: 8 }}>Make this my Default Address</label>
            </div>

            <div className="container2">
              <button className="button2" onClick={addAddress}>ADD ADDRESS</button>
            </div>

            <div className="container1 mt-5">
              <h3>SAVED ADDRESSES</h3>

              {addressList.map(addr => (
                <div key={addr.contact_id} className="saved-address-card">
                  <div className="saved-address-header">
                    <input type="radio" name="selectedAddress"
                      checked={selectedAddressId === addr.contact_id}
                      onChange={() => setSelectedAddressId(addr.contact_id)}
                    />
                    <div>
                      <b>{addr.name}</b>
                      <p>{addr.address}</p>
                      <p>{addr.location}, {addr.city}, {addr.state} - {addr.pincode}</p>
                      <p>{addr.phone}</p>
                      <p><b>{addr.address_type}</b></p>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end">
                    <button
                        className={`button3 ${
                          selectedAddressId === addr.contact_id ? "active" : ""
                        }`}
                        onClick={() => setSelectedAddressId(addr.contact_id)}
                      >
                        DELIVER HERE
                      </button>   
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-5 col-md-3 col-sm-12 address-price-section">
            <p className="section-title">
              PRICE DETAILS ({cartCount} Item{cartCount !== 1 ? "s" : ""})
            </p>

            <div className="price-row"><span>Total MRP</span><span>₹{subtotal}</span></div>
            <div className="price-row"><span>Discount on MRP</span><span className="green">-₹{totalDiscount}</span></div>
            <hr />
            <div className="price-row total"><span>Total Amount</span><span>₹{grandTotal}</span></div>
            
            <button
                  className="button3"
                  onClick={() => {
                    if (!selectedAddressId) {
                      toast.error("Please select an address");
                      return;
                    }
                    localStorage.setItem("selected_address_id", selectedAddressId);
                    navigate("/payment");
                  }}
                >
                  PROCEED TO PAYMENT
                </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Address;
